module.exports = "<button  *ngIf='!crossrefRecordsLs.length' (click)='run()'>\n  Check {{type}}\n</button>\n<div class='main' *ngIf='running'> CROSSREF INQUIRY STARTED </div>\n<div *ngIf='crossrefRecordsLs.length' class='main'>\n  <div class='button'>\n    <button (click)='close()'>Close</button>\n  </div>\n  <app-crossref-record-box *ngFor='let cr of crossrefRecordsLs'\n      [record]='cr'></app-crossref-record-box>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crossref-box/crossref-box.component.html
// module id = 421
// module chunks = 0